enum PlayButtonSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
export { PlayButtonSize };
